$(document).on(
  "metaslug_sinhnhat1tuoi_required_popup rendered", {},
  function (event, uniqueId) {
    var $this = $("#" + uniqueId);

    // console.log(event);
    // console.log(uniqueId);
    // console.log($this);btn__huongdan
    $(".btn__huongdan").on("click", function (e) {
      $("#popup_reward_wish, #popup_history").removeClass("active");
    });
    $(".popup__close").each(function () {
      $(this).on("click", function () {
        $(this).closest(".popup").removeClass("active");
        // $("html").removeClass("popup-opened");
      });
    });

    //   document.addEventListener('click', function () {
    //     var iframe = document.getElementById('youtube-video');
    //     iframe.src += "&autoplay=1";
    // }, { once: true });
  }
);